<template>
  <VModal :show="show" title="شارژ غذا" :large="true">
    <div class="grid grid-cols-5 text-white">
      <div
          class="text-center py-4 px-2 text-sm border rounded m-2 cursor-pointer"
          :class="food.Lock === '0' ? 'border-green-500' : 'border-red-500'"
          v-for="food in foodList"
          :key="food"
          @click="selectedFood = food">
        {{ food.KalaName }}
        <br>
        ({{ food.Mojodi }})
      </div>
    </div>
    <hr class="my-2">
    <div class="grid grid-cols-3 align-top p-4">
      <h1 class="text-lg text-white shrink-0">{{ selectedFood.KalaName ?? 'غذای مورد نظر را انتخاب کنید' }}</h1>

      <Input class="self-baseline" placeholder="تعداد..." v-model="chargeQuantity"/>

      <div class="grid grid-cols-2 mr-4">
        <Button class="text-white bg-transparent border-2 border-yellow-500" @click="chargeFood('-')">کاهش</Button>
        <Button class="mr-4" @click="chargeFood('+')">افزایش</Button>
        <Button class="mt-4 col-span-2 mr-2" @click="toggleFood">فعال / غیرفعال</Button>
      </div>
    </div>
  </VModal>
</template>

<script>
import VModal from "../General/VModal";
import {getChargeFoodList, postChargeFood, toggleFoodState} from "../../API/API";
import Input from "../Input";
import Button from "../General/Button";

export default {
  name: "ChargeFoodModal",
  props: ['show', 'monitorId'],
  components: {Button, Input, VModal},
  data() {
    return {
      foodList: [],
      selectedFood: {},
      chargeQuantity: ''
    }
  },
  created() {
    this.getFoodList()
  },
  methods: {
    chargeFood(type) {
      let quantity = type === "+" ? this.chargeQuantity : this.chargeQuantity * -1

      postChargeFood(this.monitorId, this.selectedFood.KalaCode, quantity)
          .then(() => this.getFoodList())
    },
    toggleFood() {
      toggleFoodState(this.selectedFood.ApprovalDetailId, this.selectedFood.Lock !== '0')
          .then(() => {
            this.getFoodList()
            this.selectedFood.Lock = this.selectedFood.Lock === '0' ? '1' : '0'
          })
    },
    async getFoodList() {
      this.foodList = (await getChargeFoodList(this.monitorId)).data.result
    }
  },
  watch: {
    async 'monitorId'() {
      this.foodList = (await getChargeFoodList(this.monitorId)).data.result
    },
    'show'() {
      if (!this.show) {
        this.selectedFood = {}
      }
    }
  },
}
</script>

<style scoped>

</style>